jQuery(document).ready(function ($) {
    const popup = `
<div class="js-popup popup" style="display: none;">
    <div class="popup__container">
        <div class="popup__top">
            <span class="js-popup-close popup__close"><i class="fa-solid fa-xmark"></i></span>
        </div>
        
        <div class="popup__content">#CONTENT#</div>
    </div>
</div>`;

    $.fn.openPopup = function () {
        return this;
    }

    $(document).on('click', '.js-popup-open', function (event) {
        event.preventDefault();

        const completePopup = popup.replace('#CONTENT#', $(this).attr('data-content'));

        //console.log(completePopup);
        $('body').append(completePopup);

        const property_ref = $('.property-info__contract--item.reference').attr('data-property-reference');

        $('input[name="property-ref"]').val(typeof(property_ref) !== 'undefined' ? property_ref : $('.main-details__address--text').text());

        // init any forms contained within
        if (window.wpcf7 && typeof wpcf7.init === 'function') {
            $('.popup .wpcf7 form').each(function () {
                wpcf7.init(this);
            });
        }

        $('.popup').fadeIn();
    });

    $(document).on('submit wpcf7submit', '.popup__content form', function (event) {
        $(this).find('.wpcf7-response-output').css('display', '');
    })

    $(document).on('click', '.popup__content .wpcf7-response-output', function (event) {
        $(this).fadeOut(500);
    });

    $(document).on('click', '.js-popup-close', function (event) {
        event.preventDefault();

        $(this).parent().parent().parent().fadeOut(function () {
            $(this).remove();
        });
    });
});